import React, { useEffect, useMemo } from 'react';
import { FilesList, Flex } from '~/ui/components';
import { useAwaitControl } from 'react-redux-await-control';
import { getTicketFiles } from '~/store/tickets/actions';
import { TicketFile } from '~/typings/entities/Ticket';

export type TicketFilesProps = {
  ticketId: string;
  refreshKey?: number;
};

export function TicketFiles({ ticketId, refreshKey = 0 }: TicketFilesProps) {
  const getTicketFilesControl = useAwaitControl(getTicketFiles);
  const ticketFiles: TicketFile[] = getTicketFilesControl.result();
  const loading = getTicketFilesControl.isRunning();

  const contentTypeToType = (contentType: string) => {
    const existsType = (type: string) => new RegExp(type, 'i').test(contentType);

    if (existsType('pdf')) return 'pdf';
    if (existsType('video')) return 'video';
    if (existsType('audio')) return 'audio';
    if (existsType('html')) return 'document';

    return 'image';
  };

  const files = useMemo(
    () =>
      ticketFiles.map((file) => ({
        name: file.fileName,
        url: file.url,
        size: file.fileSize,
        date: file.createdAt,
        type: contentTypeToType(file.contentType),
      })),
    [ticketFiles],
  );

  useEffect(() => {
    getTicketFilesControl.start({ ticketId });
  }, [ticketId, refreshKey]);

  return (
    <Flex pt={24} ph={12}>
      <FilesList files={files} loading={loading} />
    </Flex>
  );
}
